var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointChart"},[_c('div',{staticClass:"title"},[_vm._v("Intensity of Risk per school")]),_c('d3-network',{attrs:{"net-nodes":_vm.nodes,"net-links":[],"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }